/**
 * @constant EligibleGenerationsForDisclaimer
 * @type {Array<string>}
 * @description An array of generations specific to the eligible generations for the disclaimer.
 **/

export const EligibleGenerationsForDisclaimer: Array<string> = ['21mm', '24mm'];

/**
 * @constant EligibleProductsForDisclaimer
 * @type {Array<string>}
 * @description An array of Product names specific to the eligible products for the disclaimer.
 **/

export const EligibleProductsForDisclaimer: Array<string> =  ['Safety Connect', 'Service Connect'];